export function AuraMetaSummary() {
  return (
    <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
      <div className="rounded-xl border border-slate-200 border-l-2 border-l-emerald-400 bg-white p-4 shadow-sm">
        <div className="text-[13px] text-slate-500">Principles</div>
        <div className="mt-1 text-[15px] text-slate-800">
          Clarity, calm motion, trust-first, quantified feedback
        </div>
      </div>
      
      <div className="rounded-xl border border-slate-200 border-l-2 border-l-amber-400 bg-white p-4 shadow-sm">
        <div className="text-[13px] text-slate-500">Accent</div>
        <div className="mt-1 text-[15px] text-slate-800">
          Action green #22c55e; neutrals; amber/red for alerts
        </div>
      </div>
      
      <div className="rounded-xl border border-slate-200 border-l-2 border-l-sky-400 bg-white p-4 shadow-sm">
        <div className="text-[13px] text-slate-500">Type & rhythm</div>
        <div className="mt-1 text-[15px] text-slate-800">
          Inter, strict hierarchy, 8pt spacing, touch-friendly
        </div>
      </div>
    </div>
  );
}